import Tools from './tools';

export default class Scroll {
    static init() {
        // Scroll

        this.manageNav();
        this.scrollTo();
    }

    static manageNav() {
        const nav = document.querySelector('.nav');
        const articles = document.querySelectorAll('.article[data-tab]');
        
        if (nav && articles.length > 0) {
            articles.forEach((article) => {
                window.addEventListener('scroll', () => {
                    if (this.isArticleInViewport(article)) {
                        if(nav.querySelector(`.nav__subAnchor[data-id="${article.dataset.tab}"]`)) {
                            nav.querySelector(`.nav__subAnchor[data-id="${article.dataset.tab}"]`).classList.add('js-active');
                        }
                    } else {
                        if(nav.querySelector(`.nav__subAnchor[data-id="${article.dataset.tab}"]`)) {
                            nav.querySelector(`.nav__subAnchor[data-id="${article.dataset.tab}"]`).classList.remove('js-active');
                        }
                    }
                });
            });
        }
    }

    static isArticleInViewport(article) {
        let isVisible = false;
        const offset = window.innerHeight * 0.25;

        if (window.pageYOffset > (Tools.offset(article).top - offset) && window.pageYOffset < (Tools.offset(article).top + article.offsetHeight - offset)) {
            isVisible = true;
        }

        return isVisible;
    }

    static scrollTo() {
        const elts = document.querySelectorAll('.nav__subAnchor');
        if (elts.length > 0) {
            elts.forEach((elt) => {
                elt.addEventListener('click', () => {
                    const cElement = document.querySelector(`article[data-tab="${elt.dataset.id}"]`);

                    window.scrollTo({
                        top: Tools.offset( cElement ).top,
                        left: 0,
                        behavior: 'smooth',
                    });
                });
            });
        }
    }
}